var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M122.34,68.83h-16.66l-.06-.21-16.53-58.62c-.57-2.01-2.52-3.44-4.63-3.4-2.14.07-3.96,1.57-4.41,3.67l-10.88,50.03s-.02.08-.03.13v.03c-.03.09-.05.18-.07.27l-8.39,38.66-18.86-49.58c-.65-1.71-2.25-2.88-4.07-2.99-1.82-.11-3.55.86-4.41,2.47l-10.38,19.54H4.66C2.09,68.83,0,70.93,0,73.5s2.09,4.67,4.66,4.67h21.09c1.73,0,3.3-.95,4.12-2.48l6.88-12.95,20.78,54.65c.68,1.8,2.43,3,4.36,3,.11,0,.23,0,.34-.01,2.05-.15,3.78-1.66,4.22-3.66l11.73-54.01s.01-.07.02-.1v-.03c.04-.11.06-.2.08-.29l6.91-31.77,12.48,44.23c.55,2,2.4,3.4,4.49,3.4h20.18c2.57,0,4.66-2.09,4.66-4.66s-2.09-4.66-4.66-4.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.46573183e7eb5edcefc2cb315cd0b639.svg";
export { ForwardRef as ReactComponent };